import { useEffect, useState } from 'react';
import GuiaAccesoCelular from './GuiaAccesoCelular';

const API = '/api';

function Fila({ label, valor }) {
  return (
    <div style={{ display: 'flex', borderBottom: '1px solid #f3f4f6', padding: '6px 0' }}>
      <div style={{ width: 220, flexShrink: 0, fontSize: 13, color: '#4b5563' }}>{label}</div>
      <div style={{ fontSize: 14, color: '#111827', fontWeight: 500 }}>{valor || '-'}</div>
    </div>
  );
}

function Seccion({ titulo, children, nivel }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <p style={{
        fontSize: nivel === 2 ? 12 : 13,
        fontWeight: 'bold',
        borderBottom: '1px solid #e5e7eb',
        paddingBottom: 4,
        marginBottom: 4,
        color: nivel === 2 ? '#374151' : '#1a3a6e',
      }}>
        {titulo}
      </p>
      {children}
    </div>
  );
}

// mostrarGuiaCelular: botón de la guía del acceso directo; solo roles de la
// lista permitida ROLES_GUIA_CELULAR (App.js).
export default function BrokerAsignado({ mostrarGuiaCelular = false }) {
  const [broker, setBroker] = useState(undefined);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${API}/mi-perfil/broker`);
        const d = await r.json();
        if (!r.ok) {
          setError(d.error || 'Error al obtener el broker asignado');
          return;
        }
        setBroker(d);
      } catch {
        setError('Error de conexión con el servidor');
      }
    })();
  }, []);

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ color: '#1a3a6e', marginBottom: 16 }}>Broker Asignado a Usuario</h2>
      {mostrarGuiaCelular && <GuiaAccesoCelular />}
      {error && <div style={{ color: '#dc2626', marginBottom: 12, fontSize: 14 }}>{error}</div>}
      {broker === undefined && !error && <div style={{ color: '#4b5563' }}>Cargando...</div>}
      {broker === null && !error && (
        <div style={{ color: '#4b5563' }}>No tienes un broker asignado.</div>
      )}
      {broker && (
        <div style={{ background: 'white', padding: 24, borderRadius: 8, maxWidth: 640, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <div style={{ marginBottom: 16, fontSize: 15, fontWeight: 'bold', color: '#1a3a6e' }}>{broker.nombre}</div>

          <Seccion titulo="Datos Generales">
            <Fila label="RFC" valor={broker.rfc} />
            <Fila label="Teléfono" valor={broker.telefono} />
            <Fila label="Email" valor={broker.email} />
            <Fila label="Entidad Federativa" valor={broker.entidad_federativa} />
            <Fila label="Ciudad" valor={broker.ciudad} />
          </Seccion>

          <p style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 8, color: '#1a3a6e' }}>Por Banco</p>

          <Seccion titulo="Afirme" nivel={2}>
            <Fila label="Ejecutivo" valor={broker.afirme_ejecutivo} />
            <Fila label="Broker" valor={broker.afirme_broker} />
          </Seccion>

          <Seccion titulo="Banorte" nivel={2}>
            <Fila label="Master Broker" valor={broker.banorte_master} />
          </Seccion>

          <Seccion titulo="Santander" nivel={2}>
            <Fila label="Master Broker" valor={broker.santander_master} />
          </Seccion>

          <Seccion titulo="Scotiabank" nivel={2}>
            <Fila label="Master Broker" valor={broker.scotiabank_master} />
          </Seccion>

          <Seccion titulo="Banamex" nivel={2}>
            <Fila label="Master Broker" valor={broker.banamex_master} />
            <Fila label="Oficina" valor={broker.banamex_oficina} />
            <Fila label="RFC" valor={broker.banamex_rfc} />
          </Seccion>

          <Seccion titulo="HSBC" nivel={2}>
            <Fila label="Marca (Master Broker)" valor={broker.hsbc_marca} />
            <div style={{ fontSize: 13, fontWeight: 'bold', color: '#374151', margin: '8px 0 4px' }}>Ejecutivo HSBC asignado</div>
            <Fila label="Apellido Paterno" valor={broker.hsbc_ejec_apellido_paterno} />
            <Fila label="Apellido Materno" valor={broker.hsbc_ejec_apellido_materno} />
            <Fila label="Nombre(s)" valor={broker.hsbc_ejec_nombres} />
            <Fila label="Subdirección" valor={broker.hsbc_ejec_subdireccion} />
            <Fila label="No. de Promotor" valor={broker.hsbc_ejec_no_promotor} />
            <Fila label="Nombre Sucursal" valor={broker.hsbc_ejec_nombre_sucursal} />
            <Fila label="Correo Ejecutivo" valor={broker.hsbc_ejec_correo} />
          </Seccion>

          <Seccion titulo="Banregio" nivel={2}>
            <Fila label="No. y Nombre Sucursal" valor={broker.banregio_no_nombre_sucursal} />
          </Seccion>
        </div>
      )}
    </div>
  );
}
